import React, {useEffect, useState} from "react";
import useStyles from "../../styles";
import Heading from "./Heading";
import AssayAccordion from "./AssayAccordion";
import AddNewAssayLink from "./AddNewAssayLink";
import {useSelector} from "react-redux";

const OrderAssays = () => {
    const cl = useStyles();
    const {catalog, complexResearch, actions, takeId}  = useSelector(state => state.assaysCatalog);
    const { orderingList, amountOfItems } = useSelector(state => state.calculator);
    const [completeOrderingList, setCompleteOrderingList] = useState(null);
    const { activePatient } = useSelector(state => state.patients);

    useEffect(() => {
        if (catalog && complexResearch && actions && orderingList && activePatient) {
            setCompleteOrderingList(
                [...orderingList]
                    .sort((a,b) => {
                        if (+a.idParent === takeId) {
                            return 1;
                        } else if (+b.idParent === takeId) {
                            return -1;
                        } else if (+a.idParent === takeId && +b.idParent === takeId) {
                            return 0;
                        } else {
                            return a.name.localeCompare(b.name);
                        }
                    })
            );
        }
    }, [catalog, complexResearch, actions, takeId, orderingList, activePatient]);

    return (<div className={cl.orderAssaysWrapper}>
        {amountOfItems > 0 && <Heading/>}
        {amountOfItems > 0 && completeOrderingList
            ? completeOrderingList.map((assay, idx) => {
                return (<AssayAccordion key={assay.id+''+idx} assay={assay}/>)
            })
            : <div className={cl.zeroAmountOfOrders}>У Вашому кошику пусто.</div>
        }
        <AddNewAssayLink/>
    </div>);
};

export default OrderAssays;
